import { Navigate, useLocation } from "react-router-dom"

const TrackCourierRedirect = () => {
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  const id = queryParams.get("id")

  return <Navigate to={`/track/${id}`} replace />
}

export default TrackCourierRedirect
